import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

export default function AppBarForInactiveUser() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" sx={{ background: '#fff' }}>
        <Toolbar>
          <div
            style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
          >
            <div>
              <img
                src="/taskmo-final-logo.svg"
                alt=""
                style={{ width: '100px', height: '50px' }}
              />
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </Box>
  );
}
